<template>
  <div class="custom-calendar-wrapper">
    <Calendar :value="internalValue" :showIcon="showIcon" :dateFormat="dateFormat" :placeholder="placeholder"
      @date-select="handleDateSelect" @keyup.enter="$emit('keyup:enter')" @focus="handleCalendarFocus"
      @click="handleCalendarFocus" tabindex="-1" />
    <InputText ref="input" v-model="displayValue" :placeholder="placeholder" class="custom-calendar-input"
      v-maska="'##/##/####'" @input="handleManualInput" @keyup.enter="$emit('keyup:enter')" />
  </div>
</template>

<script>
import { maska } from 'maska'

export default {
  name: 'CustomCalendar',
  directives: { maska },
  props: {
    value: {
      type: Date,
      default: null
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    dateFormat: {
      type: String,
      default: 'dd/mm/yy'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalValue: this.value,
      displayValue: this.formatDate(this.value)
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
      this.displayValue = this.formatDate(newVal)
    }
  },
  methods: {
    handleDateSelect(value) {
      this.internalValue = value
      this.displayValue = this.formatDate(value)
      this.$emit('input', value)
    },
    handleManualInput(event) {
      if (event.length === 10) {
        const [day, month, year] = event.split('/')
        const date = new Date(year, month - 1, day)
        if (!isNaN(date.getTime())) {
          this.internalValue = date
          this.$emit('input', date)
        }
      }
    },
    formatDate(date) {
      if (!date) return ''
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    handleCalendarFocus(event) {
      const input = event.target; 
      if (input) {
        input.focus();
        input.style.opacity = '1';
        input.style.background = 'white';
      }
    }
  }
}
</script>

<style scoped>
.custom-calendar-wrapper {
  position: relative;
}

.custom-calendar-input {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 2.357rem);
  height: 100%;
  background: transparent;
  opacity: 0;
}

.custom-calendar-input:focus {
  opacity: 1;
  background: white;
}
</style>